import { Controller } from '@hotwired/stimulus';

import Trix from 'trix';

Trix.config.lang.bold = 'Fett';
Trix.config.lang.italic = 'Kursiv';
Trix.config.lang.strike = 'Durchgestrichen';
Trix.config.lang.urlPlaceholder = 'Link einfügen…';

export default class extends Controller {
  static targets = ['input', 'trixEditor', 'toolbar'];
  static values = {
    enabled: { type: Boolean, default: false },
  };

  connect() {
    this.form = this.inputTarget.form;
    this.form.addEventListener('ajax:beforeSend', this.disable.bind(this));
    this.form.addEventListener('ajax:error', this.enable.bind(this));
    this.form.addEventListener('ajax:success', this.reset.bind(this));

    this.trixEditorTarget.addEventListener(
      'trix-selection-change',
      this.showToolbar.bind(this)
    );

    if (this.enabledValue) {
      this.enable();
    }
  }

  showToolbar() {
    const [start, end] = this.editor.getSelectedRange();
    if (start === end) {
      this.toolbarTarget.hidden = true;
      return;
    }

    let { left, top } = this.editor.getClientRectAtPosition(start);
    top = window.pageYOffset + top - this.toolbarTarget.clientHeight;
    this.toolbarTarget.style.left = `${left}px`;
    this.toolbarTarget.style.top = `${top}px`;
    this.toolbarTarget.hidden = false;
  }

  hideToolbar() {
    this.toolbarTarget.hidden = true;
  }

  disable() {
    this.trixEditorTarget.contentEditable = false;
    this.isDisabled = true;
  }

  enable() {
    this.trixEditorTarget.contentEditable = true;
    this.isDisabled = false;
  }

  reset() {
    this.editor.loadHTML('');
    this.enable();
  }

  submitForm(event) {
    if (this.isDisabled) {
      event.preventDefault();
    }
  }

  get editor() {
    return this.trixEditorTarget.editor;
  }
}
